"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _useStylesUtils = require("../../hooks/useStylesUtils");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = (props, isOpen) => {
  const {
    fontFamily
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    maskProps
  } = (0, _useStylesUtils.useStylesUtils)();
  const {
    anchorWidth = 'fit-content'
  } = props;
  const ccMenuStyle = (0, _react.useMemo)(() => {
    const ccMenuMask = (0, _css.css)({
      ...maskProps(isOpen)
    });
    const ccMenu = (0, _css.css)({
      fontFamily: fontFamily,
      display: anchorWidth === 'auto' ? 'block' : 'inline-block',
      position: 'relative'
    });
    return {
      ccMenuMask,
      ccMenu
    };
  }, [anchorWidth, fontFamily, isOpen, maskProps]);
  return {
    'cc-Menu-mask': ccMenuStyle.ccMenuMask,
    'cc-Menu': ccMenuStyle.ccMenu
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;